import { useAtom } from 'jotai';
import { explorerItemAtomFamily } from "@/state/jotai/atom/explorerItemAtomFamily.ts";

const useExplorerItem = (itemKey: string) => {
  return useAtom(explorerItemAtomFamily(itemKey));
};

export default useExplorerItem;

/*import { useAtomValue } from "jotai";
import { explorerItemsAtom } from "@/state/jotai/atom/explorerItemsAtom";
import {ExplorerItem} from "@/types/types.ts";

function useExplorerItem(itemId: string): ExplorerItem | null {
  const explorerItems = useAtomValue(explorerItemsAtom);
  return explorerItems[itemId] || null;
}

export default useExplorerItem;*/
